import React, { useState, useEffect } from "react";

import "./FormInput.scss";

import classNames from "classnames";

import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const FormInput = ({
  inputRef,
  inputId,
  placeholder,
  type,
  value,
  change,
  error,
  errorText,
  update,
  disabled,
  onHandleBlur,
  onHandleFocus,
  isRequired,
  otherProperties,
  visibilityPassword,
}) => {
  const { t } = useTranslation();
  const [inputType, setInputType] = useState(type);
  const [showError, setShowError] = useState(error);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const [emptyAndRequiredError, setEmptyAndRequiredError] = useState(false);

  useEffect(() => {
    setInputType(type);
  }, [type]);

  useEffect(() => {
    if (error || emptyAndRequiredError) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [value, error, emptyAndRequiredError]);

  const messageError = emptyAndRequiredError
    ? t("ThisFieldIsRequired")
    : errorText
    ? errorText
    : "";

  const textError = { "inleverFormInput-text-error": error };

  return (
    <div className="inleverFormInput">
      <Form.Control
        id={inputId ? inputId : null}
        itemRef={inputRef}
        className={classNames("inleverFormInput-text", textError)}
        type={inputType}
        autoComplete={type === "password" ? "off" : "on" }
        onBlur={(e) => {
          if (onHandleBlur) {
            onHandleBlur(e);
          }
          if (hasBeenFocused && value === "" && isRequired) {
            setEmptyAndRequiredError(true);
          }
        }}
        onFocus={(e) => {
          setEmptyAndRequiredError(false);
          setHasBeenFocused(true);
          if (onHandleFocus) {
            onHandleFocus(e);
          }
        }}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(x) => change(x.target.value, x)}
        onKeyPress={(event) => event.key === "Enter" && update && update()}
        {...otherProperties}
      />
      {type === "password" && visibilityPassword && (
        <span
          className={"password-visibility-icon"}
          onMouseDown={() => {
            setPasswordVisibility(true);
            setInputType("text");
          }}
          onMouseUp={() => {
            setPasswordVisibility(false);
            setInputType("password");
          }}
        >
          {passwordVisibility ? "visibility_off" : "visibility"}
        </span>
      )}
      {showError && (
        <div className="inleverFormInput-errorText">{messageError}</div>
      )}
    </div>
  );
};
